// Pieces of the Notes-with-Back view (BRIEFS C7.5, design _v2/design/NotesFromQuestion.dc.html):
// the dark pinned bar with the big Back button, the box around the place that answers the
// question, and the second Back button after that part of the notes.
// The Notes screen (pages/app/AppNotes.js) draws them when it gets a `qmode` object:
//   { number, at, backLabel, endLabel, line1, line2, onBack(button), boxText? }
// boxText(kind) (optional, Revision C8.1) gives the box label instead of "… Question N …".
// pages/app/AppTestNotes.js makes that object for a test (and its result); Revision (C8.1)
// can make its own with backLabel "Back to Revision".
import React from 'react';
import { C, FONT } from './theme';

const IconBack = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M19 12H5M11 6l-6 6 6 6" /></svg>
);
const IconDown = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M12 4v12M6 11l6 6 6-6" /></svg>
);

// Dark bar at the top (pinned while the notes scroll).
export function BackBar({ qmode }) {
  return (
    <div data-testid="v2-qn-bar" style={{
      display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 16, padding: '12px 24px',
      background: C.bar, color: '#FFFFFF',
    }}>
      <button type="button" data-testid="v2-qn-back" onClick={() => qmode.onBack('bar')} style={{
        display: 'flex', alignItems: 'center', gap: 10, height: 52, padding: '0 22px', border: 0,
        borderRadius: 10, background: '#FFFFFF', color: C.primaryDark, fontFamily: FONT.ui,
        fontSize: 16, fontWeight: 600, cursor: 'pointer',
      }}>
        <IconBack />{qmode.backLabel}
      </button>
      <div style={{ flex: '1 1 280px', display: 'flex', flexDirection: 'column', gap: 2 }}>
        {qmode.line1 && <div data-testid="v2-qn-line1" style={{ fontSize: 15, fontWeight: 600 }}>{qmode.line1}</div>}
        {qmode.line2 && <div data-testid="v2-qn-line2" style={{ fontSize: 13 }}>{qmode.line2}</div>}
      </div>
    </div>
  );
}

// The blue box: "The answer to Question N is here" (a point) or
// "Read this part for Question N" (a whole unit).
export function AnswerBox({ label, children, testId = 'v2-qn-box' }) {
  return (
    <div data-testid={testId} style={{
      boxSizing: 'border-box', padding: '14px 16px', border: `3px solid ${C.primary}`, borderRadius: 10,
      background: C.tint, display: 'flex', flexDirection: 'column', gap: 6,
    }}>
      <div data-testid={`${testId}-label`} style={{
        display: 'flex', alignItems: 'center', gap: 8, fontFamily: FONT.ui, fontSize: 13,
        fontWeight: 600, color: C.primaryDark,
      }}><IconDown />{label}</div>
      {children}
    </div>
  );
}

export function boxLabel(kind, number) {
  if (!number) return kind === 'unit' ? 'Read this part' : 'The answer is here';
  return kind === 'unit' ? `Read this part for Question ${number}` : `The answer to Question ${number} is here`;
}

// "I have read it. Back to Question N" — after the part he was sent to read.
export function EndBackButton({ qmode }) {
  return (
    <button type="button" data-testid="v2-qn-end-back" onClick={() => qmode.onBack('end')} style={{
      alignSelf: 'flex-start', display: 'flex', alignItems: 'center', gap: 10, height: 48,
      marginTop: 10, padding: '0 20px', border: 0, borderRadius: 10, background: C.primary,
      color: '#FFFFFF', fontFamily: FONT.ui, fontSize: 15, fontWeight: 600, cursor: 'pointer',
    }}>
      <IconBack size={18} />{qmode.endLabel}
    </button>
  );
}
